<script setup lang="ts">
import './assets/style.scss'
import { computed, type PropType } from 'vue'
import { InventObject } from '@/widgets'
import { VIcons } from '@/shared/ui'
import { useHelpers } from '@/shared/lib'

const props = defineProps({
  items: {
    type: Array as PropType<InventObject[]>,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
})

const { getColorForBackground } = useHelpers()
const emits = defineEmits(['selected'])

/** Вычисляем список сгруппированных элементов */
const elems = computed(() => {
  if (!props.items) return {}

  const result: {
    [key: number]: {
      icon: string
      bgColor: string
      color: string
      count: number
      ids: number[]
    }
  } = {}

  props.items.forEach((item: InventObject) => {
    const objectId = item.getObjectTypeId()
    const bgColor = item.getStyles().fill.slice(0, 7)

    if (!result[item.getObjectTypeId()]) {
      result[objectId] = {
        icon: item.getType().icon,
        bgColor: bgColor,
        color: getColorForBackground(bgColor),
        count: 0,
        ids: [],
      }
    }

    result[objectId].count++
    result[objectId].ids.push(item.getId())
  })

  return result
})

/**
 * Функция обработки выбора элемента
 * @param ids
 */
const clickHandler = (ids: number[]) => {
  emits('selected', ids)
}
</script>

<template>
  <div class="v-map-invent-cluster" :class="{ 'v-map-invent-info-marker_disable': disabled }">
    <span
      v-for="elem in elems"
      :style="{ backgroundColor: elem.bgColor, color: elem.color }"
      @click.stop="clickHandler(elem.ids)"
    >
      <VIcons :type="elem.icon" />
      {{ elem.count }}
    </span>
  </div>
</template>
